angular.module('iqxCore')
.controller('actionDialogViewDocumentsCtrl', function ($scope, FormSvc, ApplicationSvc, ApiSvc, $window, $q, $timeout, $http,  QuestionnaireSvc, Upload, LanguageSvc) {
    var lang = LanguageSvc.lang
    FormSvc.setOptions($scope,{
        fetchAPI:'callresult/NetCandidateDocumentsFiltered?pPersonID='+$scope.actiondialogparams.linkID,
        fetchTarget:'documents',
        multiRow:true
    })

    $scope.download=function(doc){
        /* Triggers the download */
        $scope.getFile(doc, 'download')
    }

    $scope.view=function(doc){
        $scope.viewTitle=doc.DocDescription||""
        $scope.getFile(doc, 'view')
    }

    $scope.getFile=function(doc, method) {
        $http.get('/api/document/doxi',{params:{id:doc.DocumentID,personid:doc.PersonID,type:doc.SpecialType}})
        .then(function(res){
            $http.get('/api/document/download?doxi='+res.data)
            .then(function(success){
                switch(method){
                    case 'download':
                        var _newTab = window.open('about:blank', '_blank')
                        setTimeout(function () { // wait a second then fill that blank tab - thus stopping that pesky popup blocker!!
                            _newTab.location.href = '/api/document/download?doxi='+res.data
                        }, 1001)
                    break

                    case 'view':
                        $scope.documentContent = '/api/document/download?doxi='+res.data
                        FormSvc.modalInfo($scope,'viewDocument',{choices:[{desc:"Close",type:"primary",code:''}]}, 'lg')
                    break
                }

            }, function(error){
                FormSvc.alert("Error", error.data, "error")
            })
        })
        .catch(function(err) {
            FormSvc.alert("Error", err.data, "error")
        })
    }

    // Upload Stuff
    $scope.uploadCleanup=function() {
        $scope.reset()
        $scope.uploadProgress=''
        $scope.uploadError=''
        $scope.theRecord={}
        $scope.tags=[]
    }

    $scope.changedType=function(){
        angular.forEach($scope.uploadTypes, function (ut) {
            if (ut.Value === $scope.theRecord.Type) {
                $scope.theRecord.Description = ut.Description
            }
        })
        $scope.tags=[]
        return QuestionnaireSvc.fetch($scope,{  // Fetch linked questions (compliance docs functionality)
            tagTarget:'tags',
            tagLocation:'P',  
            documentType:$scope.theRecord.Type,  
            id:$scope.actiondialogparams.linkID
        })    
        .then(function(){
            if ($scope.tags && $scope.tags.length) {
                QuestionnaireSvc.reset($scope,{tagTarget:'tags'})  // Ensure in pristine state
                $timeout(function(){  // Must be done after fully loaded
                    QuestionnaireSvc.linkFormFields($scope,{tagTarget:'tags'})
                    $scope.$broadcast('isEditing',true)
                },0,true,true)
            }
        })
        .catch(function (e) {

        })
    }

    $scope.showUploadProgress=function(evt) {
        var s='Uploading...'
        if (evt && evt.total) {  // progress callback
            s=s + parseInt(100.0 * evt.loaded / evt.total) + '%'
        }
        $scope.uploadProgress=s
    }

    $scope.uploadFileName=function() {
        if ($scope.theRecord.file) {
            return $scope.theRecord.file.name
        } else {
            return 'Select file..'
        }
    }

    $scope.uploadSelect=function(files,file,event) {
        /* File selected for upload */
        $scope.theForm.file.$touched=true  // Show any validation error on the selected file
    }

    $scope.uploadExecute=function() {
        $scope.setSubmitted(true) // Ensure all validation errors appear
        if ($scope.uploadProgress || $scope.theForm.$invalid) {return}
        $scope.uploadError=''
        $scope.showUploadProgress()
        Upload.upload({
            url:'/api/document/upload',
            file:$scope.theRecord.file,
            fileFormDataName:'file',
            headers:{
                'X-Auth':ApplicationSvc.currentUser.token
            },
            fields:{
                'Type':$scope.theRecord.Type,
                'Description':$scope.theRecord.Description,
                'PersonID':$scope.actiondialogparams.linkID
            }
        })
        .then(function (res) {
            ApiSvc.CheckIQXResult(res.data)  // Checks the IQXResult construct and, if failed, throws exception with the message
            $scope.uploadProgress='Upload complete'
            return $timeout(function() {}, 2000)  // Display the Upload complete message for 2 seconds before refreshing and cleaning up
        }, null, $scope.showUploadProgress) // 3rd arg is the progress callback
        .then(function() {
            if ($scope.tags && $scope.tags.length) {  // Save the questionnaire
                $scope.qanswers=QuestionnaireSvc.answers($scope,{tagTarget:'tags'})
                return $scope.exec('call/NetQuestSet',{
                    qanswers:$scope.qanswers,
                    pID:$scope.actiondialogparams.linkID,
                    pLocation:'P'
                })
            }
        })
        .then(function() {
            FormSvc.alert("File Uploaded", "Your file has been uploaded\n\nYou will need to tick the \"Web Publish\" option within IQX before it is shown on the web.", "success")
            return $scope.fetch()  // Refresh the list
            })
        .then(function() {
            $scope.uploadCleanup()
        })
        .catch(function (err) {
        $scope.uploadProgress=''
            return $q.reject($scope.uploadError=ApiSvc.ExtractError(err))
        })
    }

    $scope.fetch()
    .then(function(){
        return $scope.fetch({
            fetchAPI: 'callresult/netuploadtypes?pOwnerType=P',
            fetchTarget: 'uploadTypes',
            multiRow: true
        })
    })
})
